import styled from 'styled-components/macro'

import Typography from '@material-ui/core/Typography'

const Title = styled(Typography)``

export default Title
